import { InjectionToken } from '@angular/core';

import { ImageSize } from './image-size';

export interface LightboxImage {
  image: string;
  imageSize: ImageSize;
}

export const LightboxImageToken = new InjectionToken<LightboxImage>('@pcs/lightboxImageToken');
